import LogoutIcon from "@mui/icons-material/Logout";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetUser } from "../redux/features/userStateSlice";
import { performSignOut } from "../utils/performSignOut";
export function Signoff() {
  const tokenLocal = sessionStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSignOff = async () => {
    if (tokenLocal) {
      await performSignOut();
      dispatch(resetUser());
      navigate("/signin");
    }
  };
  return (
    <IconButton onClick={handleSignOff}>
      <LogoutIcon></LogoutIcon>
    </IconButton>
  );
}
